import { getInGridCtaInlineStyle } from "@/utils/ingridCtaInlineStyle"
import { InGridCopyBlockConfig } from "@/utils/ingridConfig"
import style from "./InGridCopyTile.module.css"

type Props = {
  config: InGridCopyBlockConfig
}

export default function InGridCopyTile({ config }: Props) {
  const tileStyles = {
    "--ns-ingrid-copy-background": config.backgroundColor || "",
    "--ns-ingrid-copy-foreground": config.textColor === "light" ? "var(--color-white)" : "var(--color-eb-text)"
  }

  const backgroundImage = config.backgroundImage ? (
    <img
      src={config.backgroundImage}
      alt={config.altText}
      loading="lazy"
      className={`ns-ingrid-bg-image ${style.backgroundImage}`}
    />
  ) : null

  const hasContent = config.eyebrow || config.headline || config.copy || config.ctaText

  const content = hasContent ? (
    <div className={`ns-ingrid-content ${style.content}`}>
      {config.eyebrow && (
        <span className="ns-ingrid-eyebrow" style={config.eyebrowColor ? { color: config.eyebrowColor } : undefined}>
          {config.eyebrow}
        </span>
      )}
      {config.headline && (
        <h2 className="ns-ingrid-headline" style={config.headlineColor ? { color: config.headlineColor } : undefined}>
          {config.headline}
        </h2>
      )}
      {config.copy && (
        <>
          <p className="ns-ingrid-copy" style={config.copyColor ? { color: config.copyColor } : undefined}>
            {config.copy}
          </p>
        </>
      )}
      {config.ctaText && config.ctaLink && (
        <a
          href={config.ctaLink}
          className="ns-ingrid-cta"
          data-cta-style={config.ctaStyle}
          style={getInGridCtaInlineStyle(config.ctaStyle, config.ctaColor, config.ctaPrimaryTextColor)}
        >
          {config.ctaText}
        </a>
      )}
    </div>
  ) : null

  const inner = (
    <>
      {backgroundImage}
      {content}
    </>
  )

  return (
    <div
      className={`ns-ingrid-tile ns-ingrid-copy-tile ${style.tile}`}
      data-content-position={config.contentPosition}
      data-desktop-width={config.desktopWidth}
      data-desktop-height={config.desktopHeight}
      data-mobile-width={config.mobileWidth}
      data-mobile-height={config.mobileHeight}
      data-has-background={!!config.backgroundImage}
      data-text-color={config.textColor}
      data-eyebrow-color={config.eyebrowColor}
      data-headline-color={config.headlineColor}
      data-copy-color={config.copyColor}
      data-cta-color={config.ctaColor}
      data-cta-primary-text-color={config.ctaPrimaryTextColor}
      style={tileStyles}
    >
      {config.blockLink ? (
        <a href={config.blockLink} className={`ns-ingrid-block-link ${style.blockLink}`}>
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  )
}
